import { render, staticRenderFns } from "./ItemizeRank.vue?vue&type=template&id=067fb22a"
import script from "./ItemizeRank.vue?vue&type=script&lang=js"
export * from "./ItemizeRank.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports